import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { centralizedHost } from "~/Utils";

interface DocumentDetailsResponse {
  id: number;
  title: string;
  title_malay: string;
  title_mandarin: string;
  image: any;
  published: any;
  module_name: any;
}

const fetchCentralizedKeyInfoBannerDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await axios.get(`${centralizedHost}/api/key-info/all-fields/${id}`);
  return response.data[0];
};

const useCentralizedKeyInfoBannerDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["centralizedKeyInfoBanner", id],
      enabled: false,
      queryFn: () => {
        return fetchCentralizedKeyInfoBannerDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useCentralizedKeyInfoBannerDetails };
